

























































import Component from 'vue-class-component'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'
import {
  EResidentStatus,
  EUserPermissions,
  ICollectionTask,
  ICollectionTasksFilters,
  IResident
} from '@zunta/configurations'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Switcher from '@/components/Switcher.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import Card from '@/components/Card.vue'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Table from '@/components/tables/Table.vue'
import Vue from 'vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/classes/User'
import Api from '@/api'
import StatusResident from '@/components/statuses/StatusResident.vue'
import { RESIDENT_STATUS_LABEL_MAP } from '@/constants'
import { ESortOrder } from '@zunta/configurations/dist/types/shared'

@Component({
  components: {
    StatusResident,
    Table,
    FacilityLabel,
    Card,
    ResidentLabel,
    Switcher,
    Select,
    DateTimeLabel,
    Icon
  }
})
export default class CollectionsTable extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EResidentStatus: any = EResidentStatus
  user: User = Api.getUser() as User

  filters: ICollectionTasksFilters = this.$route.query.type && this.$route.query.type === 'all'
    ? {
      skip: 0,
      limit: 20,
      type: this.$route.query.type && this.$route.query.type === 'all' ? 'all' : 'today',
      onlyMyTasks: !(this.$route.query.onlyMyTasks && this.$route.query.onlyMyTasks.toString() === 'false'),
      active: true,
      sortBy: 'taskDate',
      sortOrder: ESortOrder.DESC
    }
    : {
      skip: 0,
      limit: 20,
      type: this.$route.query.type && this.$route.query.type === 'all' ? 'all' : 'today',
      onlyMyTasks: !(this.$route.query.onlyMyTasks && this.$route.query.onlyMyTasks.toString() === 'false'),
      active: true
    }

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: true,
    usePagination: true,
    stickyScrollbar: true,
    fetchFunction: this.residentModuleInstance.fetchCollectionTasksByFilters,
    rowClick: this.gotoCollecting,
    maxHeight: 'calc(100vh - 450px)',
    minHeight: '100px',
    columns: [
      {
        minWidth: '250px',
        width: 15,
        key: 'facility',
        searchKey: 'facility',
        label: 'Facility',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 15,
        key: 'resident',
        searchKey: 'resident',
        label: 'Resident',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 14,
        key: 'status',
        searchKey: 'status',
        label: 'Status',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.select,
        options: this.residentStatusListItems
      },
      {
        minWidth: '200px',
        width: 14,
        key: 'actionEvent',
        searchKey: 'actionEvent',
        label: 'Action Event',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        class: 'text-center',
        minWidth: '240px',
        width: 14,
        key: 'taskDate',
        searchKey: 'taskDate',
        label: 'Due Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '150px',
        width: 14,
        key: 'assignedUser',
        searchKey: 'assignedUser',
        label: 'Assign',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '80px',
        width: 14,
        key: 'due',
        label: 'Due',
        type: ETableColumnType.default
      }
    ]
  }

  get collectionTasks () {
    return this.$store.state.resident.collectionTasks
  }

  get collectionTasksTotal () {
    return this.$store.state.resident.collectionTasksTotal
  }

  get residentStatusListItems () {
    return [
      {
        content: RESIDENT_STATUS_LABEL_MAP[EResidentStatus.ACTIVE],
        value: EResidentStatus.ACTIVE,
        key: EResidentStatus.ACTIVE
      },
      {
        content: RESIDENT_STATUS_LABEL_MAP[EResidentStatus.INACTIVE],
        value: EResidentStatus.INACTIVE,
        key: EResidentStatus.INACTIVE
      }
    ]
  }

  toggleSwitch (value: boolean) {
    this.filters = {
      ...this.filters,
      onlyMyTasks: value
    }
  }

  gotoCollecting (task: ICollectionTask) {
    const residentId = (task.resident as IResident).id
    if (this.user.hasPermissionFor(EUserPermissions.REVIEW_COLLECTIONS)) {
      this.$locationManager.rememberAndGoTo({
        name: 'management-collection-resident',
        params: {
          residentId: residentId.toString()
        },
        query: {
          type: (this.filters.type ? this.filters.type : 'all').toString()
        }
      })
    }
  }

  openNotAssigned () {
    const routeData = this.$router.resolve({
      name: 'management-collections-sections-today',
      query: {
        type: 'all'
      }
    })
    this.$locationManager.openNewTab(routeData.href)
  }
}
